import { TimelineMax, Power1 } from "gsap";
import { ResourceIdentifier } from "../../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, LoadingStage, ResourceManager } from "../../../ResourceManager/ResourceManager";
import { SpriteResource } from "../../../ResourceManager/SpriteResource";
import { BigWinCountAnimation } from "../../../slot/BigWinCountAnimation";
import { CanvasSprite } from "../../Sprite/CanvasSprite";
import { Scale, SetStyles, Size, CreateElement } from "../../.././MyHelpers";
import { SpinAndHold2 } from "./SpinAndHold2";
import { SpinAndHoldBonusFactory2 } from "./SpinAndHold2Factory";
import { SpinAndHold2Params } from "./SpinAndHold2Params";
import { ZIndex } from "../../../ZIndex";
import { MyCanvas } from "../../MyCanvas";
import { SpinAndHoldCommonConfiguration } from "../../../api";

export class SpinAndHold2_2Screen extends SpinAndHold2 {
	public constructor(gameResid: ResourceIdentifier, params: SpinAndHold2Params, config: SpinAndHoldCommonConfiguration) {
		super(gameResid, params, config);
		this.fontHeightWinShow = Scale.fh(110);
	}

	public override async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void> {
		await super.ResourcesLoaded(loadingStage, resourceManager);


		this.StickyBonus.style.width = Scale.Wpx(762);
		this.StickyBonus.style.height = Scale.Hpx(174);
		this.StickyBonus.style.top = Scale.Ypx(355);


	

		
		// let freegameStats: HTMLElement = this.view.querySelector(".freegame-stats");
		// freegameStats.style.width = Scale.Wpx(691);
		// freegameStats.style.left = Scale.Xpx(70);

		// let freegamesleft: HTMLElement = this.view.querySelector(".freegames-left");
		// freegamesleft.style.width = Scale.Wpx(1920);

		// this.left.style.left = Scale.Xpx(48.80)		
	}

	protected override BigCountAnimation(resourceManager: ResourceManager) {
		this.bigWinCountAnimation = new BigWinCountAnimation(this.resid, new Size(Scale.W(536), Scale.H(430)), Scale.fh(120), this.resid.ScopedResourceName("bigwincount"));

		let countView = this.bigWinCountAnimation.View();
		countView.style.position = "relative";
		//countView.style.top = Scale.Ypx(600);
		//countView.style.left = "32px";
		//countView.style.width = Scale.Wpx(1920);
		countView.style.pointerEvents = "none";

		this.win.style.left = Scale.Xpx(2);
		this.win.style.top = Scale.Ypx(0);
		this.win.appendChild(countView);
	}

	protected override CanvaswinCount(resourceManager: ResourceManager) {
		super.CanvaswinCount(resourceManager);
		SetStyles(this.winCountcanvas.View(),{
			top:Scale.Ypx(-23),
			left:"0px",
		});			
		
		SetStyles(this.SFXBackground.View(),{
			top:Scale.Ypx(-27),
			left:Scale.Ypx(42),
		});
	}

	public override RemainigContainer(resourceManager: ResourceManager) {
		super.RemainigContainer(resourceManager);

		//let freegameStats: HTMLElement = this.view.querySelector(".freegame-stats");
		this.freegameStats.style.width = Scale.Wpx(691);
		this.freegameStats.style.left = Scale.Xpx(70);

		let freegamesleft: HTMLElement = this.view.querySelector(".freegames-left");
		freegamesleft.style.width = Scale.Wpx(1920);

		this.left.style.left = Scale.Xpx(48.80)


		this.ContainerSprite.View().style.left = Scale.Xpx(-146);


	}

	public override StickyBonusLoaded(resourceManager: IReadOnlyResourceManager) {
		super.StickyBonusLoaded (resourceManager);
		SetStyles(this.winStats, {
			left: Scale.Xpx(133),
			top: Scale.Ypx(457),
			position: "absolute",
			width: Scale.Wpx(536),
			height: Scale.Hpx(430),
			zIndex : ""+ ZIndex.BonusWin,
		});

		this.WinValueSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("HoldAndSpin").Add(this.gameName + "ValueContainer")).sprite, canvasSize: new Size(Scale.W(536), Scale.H(430))});
		this.WinValueSprite.View().style.display = "block";
		this.WinValueSprite.View().style.position = "absolute";
		this.WinValueSprite.View().style.top = Scale.Ypx(0);
		//this.WinValueSprite.View().style.zIndex = ""+ ZIndex.BonusWin
		this.WinValueSprite.Start(true);
		this.winStats.appendChild(this.WinValueSprite.View());

		this.totalwin.style.fontSize = Scale.fhpx(30);
		//this.totalwin.style.left="-8px";
		this.totalwin.style.top = Scale.Ypx(-149);
		this.totalwin.style.left = Scale.Ypx(164);
		
		this.totalwin.style.width = Scale.Wpx(207);
		//this.totalwin.style.zIndex = ""+ ZIndex.BonusWin;
		//this.win.style.zIndex = ""+ ZIndex.BonusWin;
	}

	protected override StickySpinTitle(resourceManager: ResourceManager) {
		this.StickyBonusSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("StickyBonus").Add("StickyTitle")).sprite, canvasSize: new Size(Scale.W(762), Scale.H(180))});
		this.StickyBonusSprite.View().style.position = "absolute";
		this.StickyBonusSprite.View().style.top = Scale.Ypx(0);
		this.StickyBonusSprite.AddOnStartCallback(() => this.audio.Play(this.resid.ScopedResourceName("TitleAnim")));
		this.StickyBonus.style.zIndex = ZIndex.HoldAndStopTitle.toString();
		this.StickyBonus.appendChild(this.StickyBonusSprite.View());
		

	}

	public override BonusWinLoaded(resourceManager: IReadOnlyResourceManager) {
		//this.BonusWin = this.view.querySelector(".game-title");

		this.BonusWinSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("StickyBonus").Add("BonusTitleStickyBonus")).sprite, canvasSize: new Size(Scale.W(762), Scale.H(180))});
		this.BonusWinSprite.View().style.position = "absolute";
		this.BonusWinSprite.View().style.top = Scale.Ypx(575);
		this.BonusWinSprite.View().style.left = Scale.Ypx(156);
		this.BonusWinSprite.View().style.zIndex= ZIndex.BonusWin.toString(),
		this.BonusWinSprite.AddOnStartCallback(() => this.audio.Play(this.resid.ScopedResourceName("TitleAnim")));

		//this.BonusStartTimer = this.systemContext.TimingContext().CreateRandomInterval("diamondStartTimer", 5000,10000, () => this.BonusWinSprite.Start(false));
		this.view.appendChild(this.BonusWinSprite.View());

		this.tl = new TimelineMax({
			paused: true,
			repeat: 0,
		});

		this.tl

			/* ball bounce up */
			.fromTo(this.BonusWinSprite.View(), 0.5, {

				y: 0,

			}, {
				y: Scale.X(-70),
				ease: Power1.easeOut, transformOrigin: "50% 50%",
			}
				, "bounce")

			/* ball bounce down */
			.to(this.BonusWinSprite.View(), 0.4, {
				transformOrigin: "50% 50%",
				y: 0,
				ease: Power1.easeIn
				//ease: Power1.easeInOut
			}, "bounce2")

			/* ball squash */
			.to(this.BonusWinSprite.View(), 0.35, {
				transformOrigin: "50% 100%",
				//scaleX: Scale.X(1),
				scaleY:0.30,
				ease: Power1.easeInOut
				//ease: Bounce.easeOut
			}, "bounce3-=0.04")

			.to(this.BonusWinSprite.View(), 0.35, {
				transformOrigin: "100% 100%",
				//scaleX: Scale.X(1),
				scaleY: 1,
				ease: Power1.easeInOut
				//ease: Bounce.easeOut
			}, "bouncefinal");




	}


	protected override SpriteWinFrameLoaded(resourceManager: IReadOnlyResourceManager) {
		this.winContainer = CreateElement("div", {
			classes: [this.resid.Scope(), "WinContainer"],
			parentToAppend: this.view,
			style: {
				position: "absolute",
				top: Scale.Ypx(738),
				left: Scale.Xpx(0),
				width: Scale.Wpx(817),
				height: Scale.Hpx(185),
				display: "none",
				//flexDirection:"column",
				zIndex: "3",
				//overflow: "hidden"
			}
		});

		// let BackgroundContainer = CreateElement("div", {
		// 	classes: ["background-container"],
		// 	parentToAppend: this.winContainer,
		// 	style: {
		// 		backgroundColor: "rgba(0,0,0,0.7)",
		// 		width: Scale.Wpx(817),
		// 		height: Scale.Hpx(185),
		// 		position: "absolute",
		// 		top: Scale.Ypx(5),
		// 		left: Scale.Xpx(24),
		// 	}
		// });

		//CHANGE TO SPRITE 
		let sprite = resourceManager.Get<SpriteResource>(this.resid.Add("frameSprite")).sprite;
		this.FrameSprite = new CanvasSprite({sprite: sprite, canvasSize: new Size(Scale.W(860), Scale.H(250))});
		this.FrameSprite.View().style.position = "absolute";
		this.FrameSprite.View().style.top = Scale.Ypx(-28);
		this.FrameSprite.AddOnStartCallback(() => this.audio.Play(this.resid.ScopedResourceName("WinCount")));


		this.WinCountAnimation = new BigWinCountAnimation(this.resid, new Size(Scale.W(860), Scale.H(250)), Scale.fh(120), this.resid.ScopedResourceName("bigwincount"));
		let countView = this.WinCountAnimation.View();
		countView.style.position = "relative";
		countView.style.top = Scale.Ypx(-47);

		this.FrameSprite.View().appendChild(countView);
		this.winContainer.appendChild(this.FrameSprite.View());
		//this.view.appendChild(this.winContainer);
	}
	protected override CanvaswinCountShow(resourceManager: ResourceManager) {
		this.WinCanvasShow = new MyCanvas(new Size(Scale.W(817), Scale.H(185)), {
            style: {
                top: Scale.Ypx(0),
				left: Scale.Xpx(24),
				position: "absolute",
				alignItems: "center",
				justifyContent: "center",
				zIndex: "" + ZIndex.BonusWin,
				display: "none",
            }
        });
		
		

		// //add gradient
		// this.ctxWinCanvasShow = this.WinCanvasShow.context;

		// //this.ctx.font = "120px Verdana" /*+ this.font*/;
		// this.ctxWinCanvasShow.font = "bold " + this.fontHeight + "px " + this.resid.ScopedResourceName("bigwincount");

		// let color: string = "orangered";
		// let color2: string = "yellow";

		// let gradient = this.ctxWinCanvasShow.createLinearGradient(
        //     this.WinCanvasShow.size.width / 2,
		// 	this.WinCanvasShow.size.height / 2 - this.fontHeight * 2 / 2,
		// 	this.WinCanvasShow.size.width / 2,
		// 	this.WinCanvasShow.size.height / 2 + this.fontHeight * 2 / 2
		// );


		// gradient.addColorStop(0, color);

		// gradient.addColorStop(0.70, color2);


		// gradient.addColorStop(1, color);


		// this.ctxWinCanvasShow.fillStyle = gradient;

		// this.ctxWinCanvasShow.textBaseline = "top";
		// this.ctxWinCanvasShow.textAlign = "center";




		this.winContainer.appendChild(this.WinCanvasShow.View());





	}



}


export class SpinAndHoldBonusFactory2_2Screen extends SpinAndHoldBonusFactory2 {

	public CreateSpinAndHoldBonus2_2Screen(gameResid: ResourceIdentifier, params: SpinAndHold2Params, config: SpinAndHoldCommonConfiguration): SpinAndHold2 {
		return new SpinAndHold2_2Screen(gameResid, params, config);
	}
}